import { bindable, bindingMode } from "aurelia-framework";

export class FacebookLogin {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public returnUrl: string = window.location.href;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public label: string = "Sign in using Facebook";
    @bindable({ defaultBindingMode: bindingMode.toView })
    public disabled: boolean = false;
}